import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import ROUTES from 'Utilities/routes';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface TriggerAiCompanionSendQueryCTAButtonClickedEventParams {
	agentResponse: string;
	prompt: string;
	success: boolean;
}

export const triggerAiCompanionSendQueryCTAButtonClickedEvent = ({
	agentResponse,
	prompt,
	success,
}: TriggerAiCompanionSendQueryCTAButtonClickedEventParams): void => {
	const label = JSON.stringify({ agentResponse, prompt });

	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { button_label: 'Send query', label, success, url: ROUTES.VEHICLE_LIST.as() },
		name: 'dlr_ai_companion_send_query_cta_button_clicked',
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
